if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    constructor() {
      super();
      this.btn = this.querySelector('.lyon-sticky-atc__btn');
      this.displayWhen = this.dataset.displayWhen || 'after-scroll';
    }
    connectedCallback() {
      // The product info column keeps a transform from the reveal-on-scroll animation, which makes it the
      // containing block for position:fixed children, so the bar scrolled with the column instead of pinning
      // to the viewport. Move the bar to <body> once; the re-connect below runs the normal setup.
      if (this.parentElement !== document.body) {
        document.querySelectorAll('body > sticky-atc').forEach((old) => old.remove());
        this.movingToBody = true;
        document.body.appendChild(this);
        return;
      }
      this.movingToBody = false;
      this.setReservedHeight();
      this.resizeHandler = () => this.setReservedHeight();
      window.addEventListener('resize', this.resizeHandler);
      const mainAtc = document.getElementById('ProductSubmitButton-template--product__main');
      if (!mainAtc && this.displayWhen === 'after-scroll') {
        const fallback = document.querySelector('.product-form__submit');
        this.observeTarget(fallback);
      } else if (mainAtc) {
        this.observeTarget(mainAtc);
      } else if (this.displayWhen === 'always') {
        this.setVisible(true);
      }
      if (this.btn) {
        this.btn.addEventListener('click', () => this.addToCart());
      }
    }
    setReservedHeight() {
      // Publish the real bar height so both the product info column AND the whole
      // product page (#MainContent, via body.has-sticky-atc) reserve matching
      // bottom space — the last tab and the last recommendation row are never
      // hidden behind the fixed bar. The body class scopes the page-bottom
      // clearance to templates that actually render the sticky bar.
      document.body.classList.add('has-sticky-atc');
      const h = this.offsetHeight;
      if (h) {
        document.documentElement.style.setProperty('--lyon-sticky-atc-height', h + 'px');
      }
    }
    setVisible(on) {
      // body.sticky-atc-visible lifts the chat launcher above the bar (snippets/lyon-sticky-atc.liquid).
      this.classList.toggle('is-visible', on);
      document.body.classList.toggle('sticky-atc-visible', on);
    }
    observeTarget(el) {
      if (!el) { this.setVisible(true); return; }
      this.observer = new IntersectionObserver(([entry]) => {
        this.setVisible(!entry.isIntersecting);
      }, { threshold: 0 });
      this.observer.observe(el);
    }
    async addToCart() {
      // Post the MAIN product form so the sticky add carries the same line properties
      // (Length, Skid plate, Color / Custom Color) and the currently selected variant
      // (e.g. Raw). The required-pick guard in lyon-order-options.js runs first (capture).
      const mainForm = document.querySelector('product-form form');
      const variantId = this.btn.dataset.variantId;
      if (!mainForm && !variantId) return;
      this.btn.disabled = true;
      this.btn.textContent = 'Adding...';
      try {
        let res;
        if (mainForm) {
          const formData = new FormData(mainForm);
          formData.set('quantity', '1');
          res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          });
        } else {
          res = await fetch('/cart/add.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          });
        }
        if (!res.ok) return;
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          const event = new CustomEvent('cart:refresh');
          document.dispatchEvent(event);
          if (typeof cartDrawer.renderContents === 'function') {
            const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
            const sections = await res.json();
            cartDrawer.renderContents({ sections });
          }
        }
        location.href = '/cart';
      } catch (e) {
        console.error('Sticky ATC error:', e);
      } finally {
        this.btn.disabled = false;
        this.btn.textContent = this.btn.dataset.originalLabel || 'Add to Cart';
      }
    }
    disconnectedCallback() {
      if (this.movingToBody) return;
      if (this.observer) this.observer.disconnect();
      if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
      document.body.classList.remove('has-sticky-atc', 'sticky-atc-visible');
    }
  }
  customElements.define('sticky-atc', StickyAtc);
}
